import { useCallback, useMemo, useState } from "react";

/** Multi-select state for bulk actions on the worklist. */
export const useSignalSelection = () => {
    const [selected, setSelected] = useState<Set<string>>(new Set());

    const toggle = useCallback((id: string) => {
        setSelected((prev) => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    }, []);

    const setAll = useCallback((ids: string[], on: boolean) => {
        setSelected((prev) => {
            const next = new Set(prev);
            ids.forEach((id) => (on ? next.add(id) : next.delete(id)));
            return next;
        });
    }, []);

    const clear = useCallback(() => setSelected(new Set()), []);

    const isSelected = useCallback((id: string) => selected.has(id), [selected]);

    return useMemo(
        () => ({
            selectedIds: Array.from(selected),
            count: selected.size,
            isSelected,
            toggle,
            setAll,
            clear,
        }),
        [selected, isSelected, toggle, setAll, clear],
    );
};
